__turbopack_context__.v({
  "error": "input-field-module-sass-module__G2yCVa__error",
  "fieldError": "input-field-module-sass-module__G2yCVa__fieldError",
  "inputStyle": "input-field-module-sass-module__G2yCVa__inputStyle",
  "label": "input-field-module-sass-module__G2yCVa__label",
  "maxHeight": "input-field-module-sass-module__G2yCVa__maxHeight",
});
